import React, { useEffect, useState } from "react";
import { HiOutlineChevronDown, HiOutlineChevronUp } from "react-icons/hi";

const CollapsibleHowItWorks: React.FC<{
  collapsible: boolean;
  title: string;
  icon?: React.ReactNode;
  defaultOpen?: boolean;
  size?: "sm" | "lg";
  className?: string;
  id?: string;
  openSignal?: number;
  children: React.ReactNode;
}> = ({
  collapsible,
  title,
  icon,
  defaultOpen = false,
  size = "sm",
  className = "",
  id,
  openSignal,
  children,
}) => {
  const [open, setOpen] = useState(defaultOpen);

  useEffect(() => {
    if (openSignal) setOpen(true);
  }, [openSignal]);

  if (!collapsible) {
    return <>{children}</>;
  }

  const lg = size === "lg";
  const headerPad = lg ? "px-5 py-4" : "px-4 sm:px-5 py-3";
  const titleCls = lg ? "text-base gap-3" : "text-sm gap-2";
  const radius = lg ? "rounded-lg" : "rounded-xl";
  const bodyPad = lg ? "px-5 pb-5 pt-2" : "px-3 sm:px-4 pb-4 pt-1";

  return (
    <div
      id={id}
      className={`border border-gray-200 ${radius} overflow-hidden ${className}`}
    >
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className={`flex items-center justify-between w-full ${headerPad} bg-white hover:bg-gray-50 transition-colors text-left`}
      >
        <span
          className={`flex items-center ${titleCls} font-semibold text-gray-800`}
        >
          {icon}
          {title}
        </span>
        {open ? (
          <HiOutlineChevronUp size={20} className="text-gray-400" />
        ) : (
          <HiOutlineChevronDown size={20} className="text-gray-400" />
        )}
      </button>
      {open && <div className={`${bodyPad} bg-white`}>{children}</div>}
    </div>
  );
};

export default CollapsibleHowItWorks;
